<div class="edit-wrapper">
  <app-software-details
    [isDialog]="true"
    [configId]="'new'"
    (dialogEvent)="closeDialog($event)"
  ></app-software-details>
</div>
